import { NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { SvgIconComponent } from 'src/app/services/svg-icon';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: 'breadcrumbs.component.html',
  styleUrls: ['breadcrumbs.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SvgIconComponent,
    NgFor,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  breadcrumbs = input<any>();
  color = input<'white' | 'grey'>('grey');
  navigationService = inject(NavigationService);

  navigate(url:string, params:string){
    if(params && params.length>0){
      this.navigationService.navigateByUrlWithParams(url, params);
    }
    else{
      this.navigationService.navigateByUrl(url);
    }
  }
}
